import React from 'react'
import { View, ViewStyle } from 'react-native'
import { observer } from 'mobx-react-lite'
import { Instance, getParent } from 'mobx-state-tree'
import { DateTime } from 'luxon'

import { Text } from '../text'

import { Action } from '@trivie/core/src/models/workflow/Action'
import { Condition } from '@trivie/core/src/models/workflow/Condition'
import { Node } from '@trivie/core/src/models/workflow/Node'

import { isAction, isCondition, isSectionHeader } from '@trivie/core/src/type-guards/isAction'

import { PathCondition } from './path-condition'
import { PathAction } from './path-action'
import { color } from '../../theme/color'

interface PathStepProps {
  step: Instance<typeof Action> | Instance<typeof Condition>
  onPress: any
  node: Instance<typeof Node>
  goToBadge?: any
  hideSeparator?: boolean
}

export const PathStep = observer((props: PathStepProps) => {
  const { hideSeparator, goToBadge, node, step, onPress } = props

  if (isAction(step) && !step?.user_visible) {
    return null
  }

  return (
    <>
      {hideSeparator ? null : (
        <View
          style={{
            ...SEPARATOR,
            backgroundColor: node?.is_completed ? 'rgb(131,172,201)' : color.shade20,
          }}
        />
      )}
      {isSectionHeader(step) ? (
        <>
          <Text
            variant="body1Emphasized"
            text={step.label}
            style={{
              fontWeight: 'bold',
              alignSelf: 'center',
              textAlign: 'center',
              marginVertical: 20,
              color: color.shade50,
            }}
          />
        </>
      ) : isCondition(step) ? (
        <PathCondition
          completed={node?.is_completed}
          onPress={onPress}
          condition={step}
          node={node}
          // @ts-ignore
          dataSet={{ qat: `path-step-${step.reference_id}` }}
        />
      ) : (
        <PathAction
          goToBadge={goToBadge}
          node={node}
          action={step}
          // @ts-ignore
          dataSet={{ qat: `path-step-${step.reference_id}` }}
        />
      )}
    </>
  )
})

const SEPARATOR: ViewStyle = { alignSelf: 'center', height: 8, width: 1 }
